import type { FC, SVGProps } from 'react';

/**
 * A 3x3 dial pad. Dots rather than a grid of squares so it stays legible at the
 * 17px the control tiles draw it at, and does not compete with the pause bars
 * beside it.
 */
const KeypadIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="2" cy="2" r="1.1" />
    <circle cx="6" cy="2" r="1.1" />
    <circle cx="10" cy="2" r="1.1" />
    <circle cx="2" cy="6" r="1.1" />
    <circle cx="6" cy="6" r="1.1" />
    <circle cx="10" cy="6" r="1.1" />
    <circle cx="2" cy="10" r="1.1" />
    <circle cx="6" cy="10" r="1.1" />
    <circle cx="10" cy="10" r="1.1" />
  </svg>
);

export default KeypadIcon;
